import React, { useEffect, useLayoutEffect } from 'react'
import '../../assets/css/components/Inputs/InputNumber.css'
import uniqueId from 'lodash/uniqueId'
import IMask from 'imask'
import { formatPipe } from '../../utils/utils'

const CurrencyInput: React.FC<InputNumberProps> = ({
  label = '',
  placeholder = '',
  register,
  error,
  rules,
  name,
  size = 'default',
  classes,
  containerClasses,
  noArrows,
  disabled,
  innerProps,
  step = 1,
  min = 0,
  addDecimals = false,
  numberOfDecimals = 0,
  mask = '',
  disableInput = false,
  value = "",
  onBlur = () => {}
}) => {
  const randomId = uniqueId('label-')


  // const element = document.getElementById('input-mask') as HTMLElement

  // let numberMask = IMask(element, {
  //   mask: Number,
  //   thousandsSeparator: ',',
  //   radix: '.'
  // })

  useEffect(() => {
    console.log("mask", mask)
  }, [mask])

  useEffect(() => {
    let numberMask
    if (!mask.includes('undefined')) {
      let element = document.getElementById(randomId) as HTMLElement
      numberMask = IMask(element, {
            mask,
            lazy: false,
            blocks: {
              num: {
                mask: Number,
                thousandsSeparator: '.',
                radix: ',', 
                scale: addDecimals ? numberOfDecimals ? numberOfDecimals : 2  : 0,           
                normalizeZeros: true,
                padFractionalZeros: addDecimals,
                min,
                max: 10000000000000
              }
            }
      })

      if (value) {
        numberMask.unmaskedValue = value
      }

      // numberMask.on('complete', () => {
      //   if (onChange) {
      //     onChange(numberMask.unmaskedValue)
      //   }
      // });

      // numberMask.cursorPos = 3
      // numberMask.updateValue()
    }
    return () => {
      numberMask?.destroy()
    }
  }, [mask, value])

  return (
    <div className={containerClasses}>
      <label
        htmlFor={randomId}
        className="font-medium text-primary-900 text-xs select-none dark:text-white"
      >
        {label}
      </label>
      <input
        id={randomId}
        // id='input-mask'
        name={name}
        className={`dark:bg-gray-600 dark:border-gray-600 mb-2 dark:text-white ${
          size === 'small'
            ? 'h-inputSmall'
            : size === 'large'
            ? 'h-inputLarge'
            : 'h-inputDefault'
        } ${error && 'border-danger focus:border-danger'} ${
          noArrows ? 'custom-input' : ''
        } ${classes}`}
        type="text"
        placeholder={placeholder}
        ref={register ? register(rules) : undefined}
        {...innerProps}
        disabled={disabled}
        autoComplete="off"
        readOnly={disableInput ? true : false}
        onBlur={(e) => {
          if (onBlur) {
            onBlur(formatPipe(e.target.value, true))
          }
        }}
        // step={step}
        // min={min}
      />
    </div>
  )
}

export default CurrencyInput

type InputProps = JSX.IntrinsicElements['input']

interface InputNumberProps {
  label?: string
  placeholder?: string
  size?: 'small' | 'large' | 'default'
  innerProps?: InputProps
  classes?: string
  containerClasses?: string
  noArrows?: boolean
  [key: string]: any
  step?: number
  min?: number
  addDecimals?: boolean
  mask?: string
  value?: string
  onBlur?: (value: any) => void
}
